import type { DomainState, IncidentDomainResponse } from '@prerender/diagnostics-api';

export const DOMAIN_TABS = ['affected', 'no_longer_affected', 'all'] as const;

export type DomainTab = (typeof DOMAIN_TABS)[number];

type DomainTabDefinition = {
  readonly label: string;
  readonly emptyMessage: string;
  readonly includes: (state: DomainState) => boolean;
};

const DOMAIN_TAB_DEFINITIONS: Record<DomainTab, DomainTabDefinition> = {
  affected: {
    label: 'Affected',
    emptyMessage: 'No affected domains',
    includes: (state) => state === 'affected' || state === 'affected_when_closed',
  },
  no_longer_affected: {
    label: 'No longer affected',
    emptyMessage: 'No domains no longer affected',
    includes: (state) => state === 'no_longer_affected',
  },
  all: { label: 'All', emptyMessage: 'No domains', includes: () => true },
};

export function domainTabLabel(tab: DomainTab): string {
  return DOMAIN_TAB_DEFINITIONS[tab].label;
}

export function emptyDomainTabMessage(tab: DomainTab): string {
  return DOMAIN_TAB_DEFINITIONS[tab].emptyMessage;
}

export function domainsInTab(
  domains: readonly IncidentDomainResponse[],
  tab: DomainTab
): readonly IncidentDomainResponse[] {
  const { includes } = DOMAIN_TAB_DEFINITIONS[tab];

  return domains.filter(({ state }) => includes(state));
}
